export class SolicitudDesembolso{

    idSolicitudDesembolso:string ;
    idOperacion: string = '';
    Fecha_Operacion: Date = new Date();
    Fecha_Solicitud_Desembolso:Date = new Date();
    pRazonSocial:string ;
    PRUC: string;
    aRazonSocial:string;
    ARUC:string;
    idProveedor: string = '';
    Scoring_Proveedor: string = '';
    idAdquirente: string = '';
    Scoring_Adquirente: string = '';
    Ranking_Adquirente: string = '';
    Tasa_Tipo_de_Calculo: string = '';
    Tasa_Mensual_Sistema: string = '';
    Tasa_Anual: string = '';
    Tasa_Mensual = 0;
    Tasa_Diaria: string = '';
    Moneda: number ;
    Moneda_Dsc: string = '';
    Adelanto_porcentaje = 0;
    Cantidad_de_Documentos_Negociables = 0;
    Fecha_Desembolso: Date = new Date();
    Fecha_Vigencia: Date = new Date();
    Estado :string = '';
    TC_Compra = 0;
    TC_Venta = 0;
    Adjunto_PDF: string = '';
    Alta_Fecha: Date = new Date();
    Alta_Canal: string = '';
    Alta_Usuario:string ;
    Baja_Fecha: string = '';
    Baja_Canal: string = '';
    Baja_Usuario: string = '';
    Direccion_Fiscal: string ='';
    Provincia: string ='';
    Distrito: string ='';
    Adelanto_Importe = 0;
}